module.exports = __webpack_public_path__ + "img/ic_trustpilot_light.b420ddb2.svg";